@if (sortable()) {
  <button
    type="button"
    class="sortable-header"
    [class.active]="isActive()"
    [attr.aria-label]="
      (isAsc()
        ? 'Ordenar por ' + label() + ', decrescente'
        : isDesc()
          ? 'Remover ordenação de ' + label()
          : 'Ordenar por ' + label() + ', crescente')
    "
    (click)="onClick()"
  >
    <span class="sortable-header__label">{{ label() | translate }}</span>
    <mat-icon class="sortable-header__icon">
      {{ isAsc() ? 'arrow_upward' : isDesc() ? 'arrow_downward' : 'unfold_more' }}
    </mat-icon>
  </button>
} @else {
  <span>{{ label() | translate }}</span>
}
